module.exports = __webpack_public_path__ + "img/flappy.d159974.svg";